<template>
  <div>
    <div id="overlay" @click="$emit('close-form')"></div>
    <div id="form">
      <div v-if="!showForm">
        <spinner />
      </div>
      <div v-else>
        <div class="column container-details">
          <div class="col-xs-12">
            <div class="form-header">
              <user-group-icon title="Usuário" />
              <h5 v-if="formType == 'edit'" class="Group-name">
                Editar grupo {{ oldName }}
              </h5>
              <h5 v-else class="Group-name">Adicionar grupo</h5>
            </div>
            <b-form novalidate class="col-xs-12 pt-1 pl-0 pr-0">
              <b-form-text id="groupNameInputHelp">Nome *</b-form-text>
              <b-form-input
                :state="nameState && notRepeatedName"
                v-model="form.NAME"
                placegolder="Nome"
                aria-describedby="groupNameInputHelp groupNameInputFeedback"
                maxlength="24"
                id="groupNameInput"
                size="sm"
              />
              <b-form-invalid-feedback
                v-if="!nameState"
                id="groupNameInputFeedback"
              >
                Campo inválido
              </b-form-invalid-feedback>
              <b-form-invalid-feedback
                v-if="!notRepeatedName"
                id="groupNameInputFeedback"
              >
                Nome já em uso
              </b-form-invalid-feedback>
            </b-form>
            <div class="group-inputs-title">Associações</div>
            <b-btn
              block
              size="sm"
              squared
              variant="orange"
              disabled
              v-if="formType == 'edit'"
              >Participantes</b-btn
            >
            <div v-if="formType == 'edit'" class="selected-box">
              <div
                class="selected-item"
                v-for="(sel, index) in groupUsers"
                :key="index"
              >
                {{ sel.LOGIN }}
              </div>
            </div>
            <b-btn
              block
              size="sm"
              rounded
              @click="
                openModal({
                  elementsType: 'agn',
                  typeName: 'Agendas',
                  selectType: 'selectCheckBox',
                  items: allElements.agn,
                  selected: selected.agn,
                })
              "
              variant="orange"
              >Adicionar ou remover Agendas ({{ selected.agn.length }}/{{
                allElements.agn.length
              }})</b-btn
            >
            <div class="selected-box" v-if="selected.agn.length">
              <div class="selected-item" v-for="agn in selected.agn">
                {{ agn.NAME }}
              </div>
            </div>
            <b-btn
              block
              size="sm"
              rounded
              @click="
                openModal({
                  elementsType: 'valve',
                  typeName: 'Válvulas',
                  selectType: 'selectCheckBox',
                  items: allElements.valve,
                  selected: selected.valve,
                })
              "
              variant="orange"
              >Adicionar ou remover Válvulas ({{ selected.valve.length }}/{{
                allElements.valve.length
              }})</b-btn
            >
            <div class="selected-box" v-if="selected.valve.length">
              <div class="selected-item" v-for="valve in selected.valve">
                {{ valve.NAME }}
              </div>
            </div>
            <b-btn
              block
              size="sm"
              rounded
              @click="
                openModal({
                  elementsType: 'sensor',
                  typeName: 'Sensores',
                  selectType: 'selectCheckBox',
                  items: allElements.sensor,
                  selected: selected.sensor,
                })
              "
              variant="orange"
              >Adicionar ou remover Sensores ({{ selected.sensor.length }}/{{
                allElements.sensor.length
              }})</b-btn
            >
            <div class="selected-box" v-if="selected.sensor.length">
              <div class="selected-item" v-for="sensor in selected.sensor">
                {{ sensor.NAME }}
              </div>
            </div>
            <b-btn
              block
              size="sm"
              rounded
              @click="
                openModal({
                  elementsType: 'hydro',
                  typeName: 'Hidrômetros',
                  selectType: 'selectCheckBox',
                  items: allElements.hydro,
                  selected: selected.hydro,
                })
              "
              variant="orange"
              >Adicionar ou remover Hidrômetros ({{ selected.hydro.length }}/{{
                allElements.hydro.length
              }})</b-btn
            >
            <div class="selected-box" v-if="selected.hydro.length">
              <div class="selected-item" v-for="hydro in selected.hydro">
                {{ hydro.NAME }}
              </div>
            </div>
            <b-btn
              block
              size="sm"
              rounded
              @click="
                openModal({
                  elementsType: 'pump',
                  typeName: 'Bombas',
                  selectType: 'selectCheckBox',
                  items: allElements.pump,
                  selected: selected.pump,
                })
              "
              variant="orange"
              >Adicionar ou remover Bombas ({{ selected.pump.length }}/{{
                allElements.pump.length
              }})</b-btn
            >
            <div class="selected-box" v-if="selected.pump.length">
              <div class="selected-item" v-for="pump in selected.pump">
                {{ pump.NAME }}
              </div>
            </div>
          </div>
        </div>
        <!-- <b-modal
        ref="elementsToGroup"
        v-if="selected[element.type]"
        centered
        hide-header
        hide-footer
        size="sm"
      >
        <h6>
          {{ element.name }} ({{ selected[element.type].length }} selecionados)
        </h6>
        <div class="equipment-table">
          <b-table
            striped
            small
            borderless
            hover
            responsive
            :items="eqps"
            :fields="fields"
          >
            <template slot="HEAD_CHECK">
              <b-form-checkbox
                @click.native.prevent="toggleAll(element.type)"
                v-model="allSelected[element.type]"
              ></b-form-checkbox>
            </template>
            <template slot="CHECK" slot-scope="row">
              <b-form-checkbox
                :value="row.item.ID"
                v-model="selected[element.type]"
              ></b-form-checkbox>
            </template>
            <template slot="NAME" slot-scope="row">
              {{ row.item.NAME }}
            </template>
          </b-table>
        </div>
        <b-btn
          v-if="$refs.elementsToGroup"
          block
          size="sm"
          @click="$refs.elementsToGroup.hide"
          >Voltar</b-btn
        >
      </b-modal> -->
        <b-modal
          ref="formError"
          no-close-on-backdrop
          centered
          hide-footer
          body-bg-variant="light"
          title="Atenção!"
        >
          <div class="modal-form row pb-3">
            <div class="col-xs-12 center-xs">
              <alert-icon title="" style="font-size: 3em; color: #ffc107" />
            </div>
            <div class="col-xs-12 error-title">
              Não é possível salvar o grupo porque:
            </div>
            <div class="col-xs-12 error-description">
              <ul>
                <li v-for="err in errors" :key="err">{{ err }}</li>
              </ul>
            </div>
          </div>
          <b-btn
            v-if="$refs.formError"
            block
            variant="secondary"
            size="sm"
            @click="$refs.formError.hide"
            >Irei corrigir</b-btn
          >
        </b-modal>
        <pickEquipmentsModal
          v-if="showEquipmentsModal"
          v-model="showEquipmentsModal"
          :elementsType="modalElements.elementsType"
          :typeName="modalElements.typeName"
          :equipments="modalElements.items"
          :selectType="modalElements.selectType"
          :selected="modalElements.selected"
          @selected="setSelected"
        />
        <footer id="footer" class="pb-2 d-flex">
          <b-btn
            size="sm"
            variant="outline-secondary"
            @click="$emit('close-form')"
            class="ml-2 mr-1 w-100"
          >
            Cancelar
          </b-btn>
          <b-btn
            variant="3v3"
            @click="checkForm"
            size="sm"
            class="ml-1 mr-2 w-100"
          >
            Salvar
          </b-btn>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import { notRepeatedName } from "@/pages/components/regist/form-functions";
import { users, listEquipments } from "@/api";
import PickEquipmentsModal from "@/common/components/PickEquipmentsModal.vue";

export default {
  name: "group-form",
  components: {
    PickEquipmentsModal,
  },
  props: {
    alreadyUsedNames: Array,
    items: {
      required: false,
      default: () => [],
    },
    formType: String,
    itemToEdit: [Number, Object],
  },
  async created() {
    await this.loadGroups();
    await this.loadEquipments();
    if (this.formType == "add") {
      this.resetForm();
    } else {
      this.form.ID = this.itemToEdit.ID;
      this.form.NAME = this.itemToEdit.NAME;
    }
    this.showForm = true;
  },
  data() {
    return {
      showForm: false,
      modalName: "",
      modalElements: {
        elementsType: "",
        typeName: "",
        selectType: "",
        items: [],
        selected: [],
      },
      isLoad: false,
      // equipment: [],
      showEquipmentsModal: false,
      users: [],
      errors: [],
      form: {
        ID: null,
        NAME: "",
        RELATED: {
          //objeto para enviar as relações para o backend cadastrar em banco
          agn: [],
          hydro: [],
          pump: [],
          sensor: [],
          valve: [],
        },
      },
      allSelected: {
        agn: false,
        valve: false,
        hydro: false,
        pump: false,
        sensor: false,
      },
      selected: {
        agn: [],
        hydro: [],
        pump: [],
        sensor: [],
        valve: [],
      },
      allElements: {
        //todos os elementos do sistema
        agn: [],
        hydro: [],
        pump: [],
        sensor: [],
        valve: [],
      },
      element: {
        type: "valve",
        name: "Válvulas",
      },
      relatedElements: {
        //elementos que têm associação com grupos
        agn: [],
        hydro: [],
        pump: [],
        sensor: [],
        valve: [],
      },
      groups: [],
      fields: [
        {
          key: "CHECK",
        },
        {
          key: "NAME",
        },
      ],
    };
  },
  watch: {
    "selected.valve": function () {
      this.allSelected.valve =
        this.selected.valve.length == this.allElements.valve.length;
    },
    "selected.hydro": function () {
      this.allSelected.hydro =
        this.selected.hydro.length == this.allElements.hydro.length;
    },
    "selected.pump": function () {
      this.allSelected.pump =
        this.selected.pump.length == this.allElements.pump.length;
    },
    "selected.sensor": function () {
      this.allSelected.sensor =
        this.selected.sensor.length == this.allElements.sensor.length;
    },
  },

  computed: {
    selectedAgnIds() {
      return (this.selected.agn = this.selected.agn.length
        ? this.selected.agn.map((e) => e.ID)
        : []);
    },
    selectedValvesIds() {
      return (this.selected.valve = this.selected.valve.length
        ? this.selected.valve.map((e) => e.ID)
        : []);
    },
    selectedSensorsIds() {
      return (this.selected.sensor = this.selected.sensor.length
        ? this.selected.sensor.map((e) => e.ID)
        : []);
    },
    selectedHydrosIds() {
      return (this.selected.hydro = this.selected.hydro.length
        ? this.selected.hydro.map((e) => e.ID)
        : []);
    },
    selectedPumpssIds() {
      return (this.selected.pump = this.selected.pump.length
        ? this.selected.pump.map((e) => e.ID)
        : []);
    },
    oldName() {
      return this.itemToEdit && this.itemToEdit.NAME;
    },
    nameState() {
      return (
        this.form.NAME && !!this.form.NAME.trim() && this.form.NAME.length < 25
      );
    },
    notRepeatedName() {
      return notRepeatedName(
        this.alreadyUsedNames,
        this.form.NAME,
        this.formType,
        this.oldName
      );
    },
    groupUsers() {
      if (
        this.formType == "edit" &&
        this.users &&
        this.users.length &&
        this.itemToEdit &&
        this.itemToEdit.ID
      ) {
        return this.users.filter((e) => e.FK_GROUP == this.itemToEdit.ID);
      }

      return this.users;
    },
    eqps() {
      return this.allElements[this.element.type];
    },
  },
  methods: {
    openModal({ elementsType, typeName, selectType, items, selected }) {
      this.modalElements = {
        elementsType,
        typeName,
        selectType,
        items,
        selected,
      };
      // console.log("func", selected);

      if (this.isLoad) {
        this.showEquipmentsModal = true;
      }
    },
    setSelected(selected, type) {
      this.selected[type] = selected;
      // console.log(this.selected[type]);
    },
    async submit(data) {
      try {
        const ret = await users.groups[this.formType](data);
        alert(ret.log, ret.alert);
        if (ret.alert === "s") {
          await this.loadGroups();
        }
      } catch (err) {
        console.error(err);
      }
      this.$emit("get-data-again");
      this.$emit("close-form");
    },

    async loadGroups() {
      this.relatedElements = await users.groups.relateds();
      // console.log(this.relatedElements);
      this.list = await users.groups.list();
      this.fullList = this.fullList = this.list.map((e) => e);
    },

    async loadEquipments() {
      this.isLoad = false;
      try {
        const usersPromisse = users.list();
        const agnPromisse = listEquipments.schedules();
        const hydrosPromise = listEquipments.hydros();
        const pumpsPromise = listEquipments.pumps();
        const valvesPromise = listEquipments.valves();
        const sensorsPromise = listEquipments.sensors();

        const [
          usersResponse,
          agnResponse,
          hydrosResponse,
          pumpsResponse,
          valvesResponse,
          sensorsResponse,
        ] = await Promise.allSettled([
          usersPromisse,
          agnPromisse,
          hydrosPromise,
          pumpsPromise,
          valvesPromise,
          sensorsPromise,
        ]);
        // console.log(sensorsResponse.value);
        this.users = usersResponse.value;
        this.allElements.agn = agnResponse.value;
        this.allElements.hydro = hydrosResponse.value;
        this.allElements.pump = pumpsResponse.value;
        this.allElements.valve = valvesResponse.value;
        this.allElements.sensor = sensorsResponse.value.sensors;

        // Filter -> selecionados
        if (this.formType != "add") {
          this.selected.agn = this.getSelectedElements("agn");
          this.selected.valve = this.getSelectedElements("valve");
          this.selected.sensor = this.getSelectedElements("sensor");
          this.selected.hydro = this.getSelectedElements("hydro");
          this.selected.pump = this.getSelectedElements("pump");
        }
      } catch (err) {
        console.error(err);
        alert("Erro ao buscar equipamentos para formulário.");
      } finally {
        this.isLoad = true;
      }
    },

    getSelectedElements(type) {
      const selectedRelated = this.relatedElements[type].length
        ? this.relatedElements[type].filter(
            (e) => e.ID_GROUP == this.itemToEdit.ID
          )
        : [];

      return this.allElements[type].filter((e) =>
        selectedRelated.some((related) => related.ID === e.ID)
      );
    },

    async checkForm() {
      this.errors = [];
      let states = [this.nameState, this.notRepeatedName];
      let erros = [
        "Nome é obrigatório. Permitidos apenas letras, números, pontos, hífens e underlines. Máximo: 24 caracteres.",
        "Nome escolhido já está em uso. Verifique.",
      ];
      states.map((e, i) => {
        if (!e) {
          this.errors.push(erros[i]);
        }
      });
      if (this.errors.length) this.$refs.formError.show();
      else {
        await this.submit({
          ID: this.form.ID,
          NAME: this.form.NAME,
          RELATED: {
            agn: this.selectedAgnIds,
            hydro: this.selectedHydrosIds,
            pump: this.selectedPumpssIds,
            sensor: this.selectedSensorsIds,
            valve: this.selectedValvesIds,
          },
        });
        // this.$emit("submit", {
        //   ID: this.form.ID,
        //   NAME: this.form.NAME,
        //   RELATED: {
        //     agn: this.selected.agn,
        //     hydro: this.selected.hydro,
        //     pump: this.selected.pump,
        //     sensor: this.selected.sensor,
        //     valve: this.selected.valve,
        //   },
        // });
        this.$emit("close-form");
      }
    },
    resetForm() {
      this.form = {
        ID: null,
        NAME: "",
        RELATED: {
          //objeto para enviar as relações para o backend cadastrar em banco
          agn: [],
          hydro: [],
          pump: [],
          sensor: [],
          valve: [],
        },
      };
      this.showPwd = false;
    },
    openElements(type) {
      if (type == "valve") {
        this.element = {
          type,
          name: "Válvulas",
        };
      } else if (type == "hydro") {
        this.element = {
          type,
          name: "Hidrômetros",
        };
      } else if (type == "pump") {
        this.element = {
          type,
          name: "Bombas",
        };
      } else if (type == "sensor") {
        this.element = {
          type,
          name: "Sensores",
        };
      } else if (type == "agn") {
        this.element = {
          type,
          name: "Agendas",
        };
      }
      this.$refs.elementsToGroup.show();
    },
    toggleAll(str) {
      this.allSelected[str] = !this.allSelected[str];
      if (this.selected[str].length < this.allElements[str].length) {
        this.selected[str] = this.allElements[str].slice().map((e) => e.ID);
      } else if (this.selected[str].length == this.allElements[str].length) {
        this.selected[str] = [];
      }
    },
  },
};
</script>

<style scoped>
.form-header {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  /* padding: 0 0rem 0.5rem 0rem; */
  border-bottom: 1px solid #eee;
  margin-bottom: 6px;
}
.form-header.material-design-icon {
  margin-bottom: 0.3em;
  margin-right: 0.3em;
  padding-bottom: 1em;
}
.material-design-icon {
  font-size: 1.3em;
  margin-bottom: 11px;
  margin-right: 4px;
}
.equipment-table {
  height: 310px !important;
  overflow-x: hidden;
  overflow-y: auto;
}
.Group-header {
  font-weight: 600;
  text-align: center;
}
.Group-name {
  font-family: "SourceSansPro_Semibold", Arial, Helvetica, sans-serif;
  text-align: center;
}
@media screen and (max-width: 768px) {
  .container-details {
    padding-bottom: 3em;
    padding-left: 0em;
    padding-right: 0;
    margin-right: 0;
  }
}
</style>
